(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-testimonials"] && !Shopify.designMode) return;
  try {
    
class TestimonialSlider {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.slider = this.section.querySelector('[id^="slider-"]');
    this.prevBtns = this.section.querySelectorAll('[class*="js-prev"]');
    this.nextBtns = this.section.querySelectorAll('[class*="js-next"]');
    this.autoplaySpeed = parseInt(this.slider?.dataset.speed || 0) * 1000;
    
    if (!this.slider) return;
    this.init();
  }

  init() {
    this.prevBtns.forEach(btn => btn.addEventListener('click', () => this.step(-1)));
    this.nextBtns.forEach(btn => btn.addEventListener('click', () => this.step(1)));
    if (this.autoplaySpeed > 0) this.startAutoplay();
  }

  getMetrics() {
    const card = this.slider.querySelector('.ba-slide');
    if (!card) return { width: 0, gap: 0 };
    const style = window.getComputedStyle(this.slider);
    const gap = parseInt(style.columnGap) || parseInt(style.gap) || 12;
    return { width: card.offsetWidth, gap: gap };
  }

  getCurrentIndex() {
    const { width, gap } = this.getMetrics();
    if (width === 0) return 0;
    return Math.round(this.slider.scrollLeft / (width + gap));
  }

  step(direction) {
    this.stopAutoplay();
    const index = this.getCurrentIndex() + direction;
    this.scrollTo(index);
  }

  scrollTo(index) {
    const cards = this.slider.querySelectorAll('.ba-slide');
    if (index < 0) index = 0;
    if (index >= cards.length) index = cards.length - 1;
    const { width, gap } = this.getMetrics();
    this.slider.scrollTo({ left: index * (width + gap), behavior: 'smooth' });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      const cards = this.slider.querySelectorAll('.ba-slide');
      const next = (this.getCurrentIndex() + 1) % cards.length;
      this.scrollTo(next);
    }, this.autoplaySpeed);
    this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
    this.slider.addEventListener('mouseleave', () => this.startAutoplay());
  }

  stopAutoplay() { clearInterval(this.autoplayInterval); }
}

const initTestimonials = () => {
  document.querySelectorAll('.section-before-after-testimonials').forEach(el => new TestimonialSlider(el));
};

document.addEventListener('DOMContentLoaded', initTestimonials);
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.classList.contains('section-before-after-testimonials')) new TestimonialSlider(e.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-afterz"] && !Shopify.designMode) return;
  try {
    
class BeforeAfterSlider {
  constructor(sectionElement) {
    this.section = sectionElement;
    this.slider = this.section.querySelector('[id^="ba-slider-"]');
    this.prevBtns = this.section.querySelectorAll('.ba-prev');
    this.nextBtns = this.section.querySelectorAll('.ba-next');
    this.dotsContainer = this.section.querySelector('[id^="ba-dots-"]');
    
    if (!this.slider) return;

    this.isSliderMode = this.slider.classList.contains('slider-mode');
    if (!this.isSliderMode) return;

    this.init();
  }

  init() {
    this.prevBtns.forEach(btn => btn.addEventListener('click', () => this.scroll('left')));
    this.nextBtns.forEach(btn => btn.addEventListener('click', () => this.scroll('right')));

    if (this.dotsContainer) {
      this.dots = Array.from(this.dotsContainer.querySelectorAll('.ba-dot'));
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.scrollToCard(index));
      });
      // Listen for scroll to update dots
      this.slider.addEventListener('scroll', () => this.updateDots());
    }
  }

  getMetrics() {
    const card = this.slider.querySelector('.ba-card');
    if (!card) return { width: 0, gap: 0 };
    const style = window.getComputedStyle(this.slider);
    const gap = parseInt(style.columnGap) || parseInt(style.gap) || 0;
    const width = card.getBoundingClientRect().width;
    return { width, gap };
  }

  getCurrentIndex() {
    const cards = Array.from(this.slider.querySelectorAll('.ba-card'));
    const scrollLeft = Math.round(this.slider.scrollLeft);
    let closestIndex = 0;
    let minDiff = Infinity;
    
    cards.forEach((card, index) => {
      // Use offsetLeft which is relative to the slider container thanks to position:relative
      const diff = Math.abs(card.offsetLeft - scrollLeft);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = index;
      }
    });
    return closestIndex;
  }

  scroll(direction) {
    const cards = Array.from(this.slider.querySelectorAll('.ba-card'));
    const currentIndex = this.getCurrentIndex();
    let nextIndex;

    if (direction === 'left') {
      nextIndex = currentIndex - 1;
    } else {
      nextIndex = currentIndex + 1;
    }

    // Clamp index
    if (nextIndex < 0) nextIndex = 0;
    if (nextIndex >= cards.length) nextIndex = cards.length - 1;

    // Force a small scroll if we are "stuck" on the same index due to minor pixel rounding
    const targetCard = cards[nextIndex];
    if (targetCard) {
      if (Math.round(this.slider.scrollLeft) === targetCard.offsetLeft && direction === 'left' && nextIndex > 0) {
        nextIndex--;
      } else if (Math.round(this.slider.scrollLeft) === targetCard.offsetLeft && direction === 'right' && nextIndex < cards.length - 1) {
        nextIndex++;
      }
      this.scrollToCard(nextIndex);
    }
  }

  scrollToCard(index) {
    const cards = this.slider.querySelectorAll('.ba-card');
    const card = cards[index];
    if (card) {
      this.slider.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
    }
  }

  updateDots() {
    const index = this.getCurrentIndex();
    if (this.dots && this.dots[index]) {
      this.dots.forEach(d => d.classList.remove('active'));
      this.dots[index].classList.add('active');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.section-before-after-results').forEach(el => {
    new BeforeAfterSlider(el);
  });
});

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.classList.contains('section-before-after-results')) {
    new BeforeAfterSlider(e.target);
  }
});

  } catch(e) { console.error(e); }
})();
})();
